module.exports = __webpack_public_path__ + "static/david-ortiz-3e7df16d92241c561017d9944e307310.jpeg";